import classNames from "classnames";
import type { FC, ReactNode } from "react";
import type { IDropdownButtonProps } from "@similarweb/ui-components";
import { DropdownButton } from "@similarweb/ui-components";

interface IFiltersBarDropdownButton extends IDropdownButtonProps {
    className?: string;
    children: ReactNode;
}

export const FiltersBarDropdownButton: FC<IFiltersBarDropdownButton> = ({ className, ...props }) => (
    <DropdownButton
        {...props}
        cssClass={classNames("DropdownButton--filtersBarDropdownButton", className)}
    />
);
